import { LinearProgress } from '@patrianna/core-components'

import classes from './styles.module.scss'

type Props = {
  threshold: number
  progressPercent: number
}
function Progress(props: Props) {
  const { threshold, progressPercent } = props

  return (
    <div className={classes.root}>
      <p className={`mt-typography-body2 ${classes.count}`}>{progressPercent}%</p>
      <p className={`mt-typography-body2 ${classes.max}`}>{threshold}</p>
      <LinearProgress value={progressPercent} className={classes.progress} barClassName={classes.primary} />
    </div>
  )
}

export default Progress
